























































































import {
  computed,
  defineComponent,
  inject,
  onBeforeUnmount,
  onMounted,
  ref,
  useMeta,
  watch
} from '@nuxtjs/composition-api';
import { SfBadge, SfButton } from '@storefront-ui/vue';
import { useTimeoutFn } from '@vueuse/core';
import VaimoIconSVG from 'atoms/VaimoIconSVG.vue';
import { storeToRefs } from 'pinia';

import VaimoLogo from '~/diptyqueTheme/components/atoms/VaimoLogo.vue';
import { useMegaMenuMobileStore } from '~/diptyqueTheme/stores/megaMenuMobile';

export default defineComponent({
  name: 'VaimoTopHeaderMobile',
  components: {
    VaimoIconSVG,
    VaimoLogo,
    SfButton,
    SfBadge
  },
  props: {
    isSimplified: {
      type: Boolean,
      default: false
    },
    cartProductsQuantity: {
      type: Number,
      default: 0
    },
    promoHeight: {
      type: Number,
      default: 0
    }
  },
  emits: [
    'search:start',
    'search:close',
    'toggle:account',
    'toggle:cart',
    'toggle:menu'
  ],
  setup(props) {
    // set promo height CSS variable on :root
    const setRootPromoHeight = (value: number) => {
      if (typeof document !== 'undefined') {
        document.documentElement.style.setProperty(
          '--promo-banner-height',
          `${value}px`
        );
      }
    };

    onMounted(() => {
      setRootPromoHeight(props.promoHeight);
    });

    watch(
      () => props.promoHeight,
      (newVal) => {
        setRootPromoHeight(newVal);
      }
    );

    const megaMenuMobileStore = useMegaMenuMobileStore();
    const { isOpen: isMobileMenuVisible } = storeToRefs(megaMenuMobileStore);
    const isHeaderTransparent = inject(
      'is-header-transparent',
      computed(() => false)
    );

    const isTransparent = computed<boolean>(
      () => isHeaderTransparent.value && !isMobileMenuVisible.value
    );

    const HEADER_ANIMATION_DURATION = 900;
    const isClosing = ref(false);

    const { start: startCloseTimeout, stop: stopCloseTimeout } = useTimeoutFn(
      () => {
        isClosing.value = false;
      },
      HEADER_ANIMATION_DURATION
    );

    watch(isMobileMenuVisible, (newVal, oldVal) => {
      if (oldVal === true && newVal === false) {
        isClosing.value = true;
        startCloseTimeout();
      } else if (newVal === true) {
        stopCloseTimeout();
        isClosing.value = false;
      }
    });

    onBeforeUnmount(() => {
      stopCloseTimeout();
    });

    const metaTags = computed(() => ({
      bodyAttrs: {
        class: isHeaderTransparent.value
          ? ['has-transparent-header']
          : ['has-opaque-header']
      }
    }));

    useMeta(() => metaTags.value);

    return {
      isMobileMenuVisible,
      isHeaderTransparent,
      isTransparent,
      isClosing
    };
  },
  head: {}
});
